import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Radio, Input, Modal, ModalProps, Row, Select, notification } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  getReplaceMakeProcessTypeName,
  getReplaceMakeTypes,
  ReplaceMakeProcessTypes,
  ReplaceMakeTypes,
} from '../../models/ReplaceMakeSupplier'
import {
  getMachiningType,
  getPotionPlaceAsync,
  isAddReplaceMakeSupplier,
  isChangeReplaceMake,
  isSetReplaceMakeSupplier,
} from './ReplaceMakeSupplierSclice'
import { stringTrim } from '../../utils/StringUtils'
// import { getTenantDetail } from './ReplaceMakeSupplierSclice'

interface TenantModalProps {
  tenantId?: string
  visible?: boolean
}

export const AddReplaceMakeSupplierModel = ({
  tenantId,
  visible,
  onCancel,
  onOk,
  ...others
}: TenantModalProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const rowProps = {
    gutter: 4,
  }

  const colProps = { span: 8 }

  const firstColumnLayout = {
    labelCol: { flex: '8rem' },
    wrapperCol: { flex: '25rem' },
  }

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }
  // 代煎类别
  const [category, setCategory] = useState([])
  // 加工方式
  const [type, setType] = useState([])

  const [isDisable, setIsDisable] = useState(true)

  const [placeIdOptions, setPlaceIdOptions] = useState<any>()

  const getDetail = () => {
    (tenantId) && dispatch(isSetReplaceMakeSupplier(tenantId))
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(getMachiningType()).then((res: any) => {
          const typeOptions: any = []
          setCategory(res.payload)
          res.payload?.forEach((el: any) => {
            el.outPotionDictList?.forEach((v: any) => {
              typeOptions.push(v)
            })
          })
          setType(typeOptions)
        })
        setIsDisable(false)
        form.setFieldsValue({
          ...res,
          decoctionType: res.decoctionType
            .split(',')
            .map((el: string) => Number(el)),
          machiningType: res.machiningType
            .split(',')
            .map((el: string) => Number(el)),
        })
      })
  }

  useEffect(() => {
    if (visible && !tenantId) {
      dispatch(getMachiningType()).then(unwrapResult).then((res) => {
        const typeOptions: any = []
        setCategory(res.payload)
        res?.forEach((el: any) => {
          el.outPotionDictList?.forEach((v: any) => {
            typeOptions.push(v)
          })
        })
        setCategory(res)
        setType(typeOptions)
      })
    }
  }, [visible])

  useEffect(() => {
    dispatch(
      getPotionPlaceAsync()
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPlaceIdOptions(res)
      })
  }, [])

  useEffect(() => {
    form.setFieldsValue({ machiningType: [], decoctionType: [] })
    if (tenantId) {
      getDetail()
    } else {
      form.resetFields()
    }
  }, [tenantId])

  return (
    <Modal
      {...others}
      visible={visible}
      title={`${tenantId ? '编辑' : '新建'}代煎饮片厂`}
      width={700}
      maskClosable={false}
      cancelText='取消'
      okText='确定'
      onCancel={(e) => {
        if (!tenantId) {
          form.resetFields()
        }
        onCancel && onCancel(e)
      }}
      onOk={(e) => {
        form
          .validateFields()
          .then((values) => {
            console.log(values)
            const data = {
              ...values,
              id: tenantId ? tenantId : null,
              decoctionType: values.decoctionType.join(','),
              machiningType: values.machiningType.join(','),
            }
            dispatch(isAddReplaceMakeSupplier(data))
              .then(unwrapResult)
              .then(() => {
                form.resetFields()
                onOk && onOk(e)
              })
            console.log(values.decoctionType.join(','))
          })
          .catch(() => {
            // Do nothing.
          })
      }}
    >
      <Form
        form={form}
        colon={false}
        autoComplete='off'
        initialValues={{ status: 0 }}
      >
        <Row {...rowProps}>
          <Col {...colProps} span={20}>
            <Form.Item
              {...firstColumnLayout}
              label='代煎饮片厂名称'
              name='name'
              {...required}
              rules={[
                { required: true, message: '机构名称不能为空' },
                { max: 50, message: '最长50位' },
              ]}
              getValueFromEvent={stringTrim}
            >
              <Input autoComplete='off' />
            </Form.Item>
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colProps} span={20}>
            <Form.Item
              {...firstColumnLayout}
              label='代煎类别'
              name='decoctionType'
              {...required}
              rules={[{ required: true, message: '代煎类别不能为空' }]}
            >
              <Select
                mode='multiple'
                placeholder='请选择代煎类别'
                onDeselect={(e) => {
                  const data = {
                    supplierId: tenantId,
                    decoctionType: e as number
                  }
                  tenantId && dispatch(isChangeReplaceMake(data)).then(unwrapResult).then((res) => {
                    getDetail()
                    notification.error({
                      message: "此代煎类别不能删除"
                    })
                  })
                }}
                onChange={(e, o) => {
                  const options: any = []
                  const machiningType: any = []
                  if (form.getFieldValue('decoctionType')?.length === 0) {
                    form.setFieldsValue({ machiningType: [] })
                    setIsDisable(true)
                    setType([])
                  } else {
                    setIsDisable(false)
                    form.getFieldValue('decoctionType')?.forEach((v: any) => {
                      category?.forEach((el: any) => {
                        if (v === el.typeVal) {
                          options.push(...el.outPotionDictList)
                        }
                      })
                    })
                    if (form.getFieldValue('machiningType')?.length !== 0) {
                      options?.forEach((el: any) => {
                        form
                          .getFieldValue('machiningType')
                          ?.forEach((v: any) => {
                            if (el.typeVal === v) {
                              machiningType.push(v)
                            }
                          })
                      })
                    }
                    form.setFieldsValue({ machiningType: machiningType })
                    console.log(
                      form.getFieldValue('machiningType'),
                      form.getFieldValue('decoctionType'),
                      type
                    )
                    setType(options)
                  }
                }}

              >
                {category?.map((l: any) => (
                  <Select.Option key={l.id} value={l.typeVal}>
                    {l.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colProps} span={20}>
            <Form.Item
              {...firstColumnLayout}
              label='渠道供应商'
              name='placeId'
              {...required}
            >
              <Select
                placeholder='请选择渠道供应商'
              >
                {placeIdOptions?.map((l: any) => (
                  <Select.Option key={l.id} value={l.id}>
                    {l.placeName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colProps} span={20}>
            <Form.Item
              {...firstColumnLayout}
              label='加工方式'
              name='machiningType'
              {...required}
              rules={[{ required: true, message: '加工方式不能为空' }]}
            >
              <Select
                mode='multiple'
                placeholder='请选择加工方式'
                disabled={isDisable}
                onChange={(e) => {
                  console.log(e)
                  console.log(form.getFieldValue('machiningType'))
                }}
                onDeselect={(e) => {
                  const data = {
                    supplierId: tenantId,
                    machiningType: e as number
                  }
                  tenantId && dispatch(isChangeReplaceMake(data)).then(unwrapResult).then((res) => {
                    getDetail()
                    notification.error({
                      message: "该加工方式有正在使用的机构，无法删除，如需删除请先解绑相关的机构"
                    })
                  })
                }}
              >
                {type?.map((l: any) => (
                  <Select.Option key={l.id} value={l.typeVal}>
                    {l.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row {...rowProps}>
          <Col {...colProps} span={20}>
            <Form.Item
              {...firstColumnLayout}
              label='饮片厂状态'
              name='status'
              {...required}
            >
              <Radio.Group>
                <Radio value={0}>正常</Radio>
                <Radio value={1}>注销</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
